module.exports = __webpack_public_path__ + "img/game_h-slot_pc_1.bd119dc5.jpg";